import React from 'react';

interface CustomersIconProps {
  className?: string;
  isActive?: boolean;
  size?: number;
}

export const CustomersIcon: React.FC<CustomersIconProps> = ({ 
  className = '', 
  isActive = false, 
  size = 25 
}) => {
  const colorClasses = isActive 
    ? 'text-[#72A8FD] group-hover:text-[#8BB8FE]' 
    : 'text-white group-hover:text-gray-200';

  return (
    <svg 
      width={size} 
      height={size * 0.68} // Maintain aspect ratio (25:17)
      viewBox="0 0 25 17" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={`${colorClasses} transition-colors duration-200 ${className}`}
    >
      <path 
        d="M18.125 8.5C18.5354 8.5 18.9417 8.42148 19.3209 8.26892C19.7 8.11636 20.0445 7.89275 20.3347 7.61086C20.6249 7.32897 20.8551 6.99431 21.0121 6.626C21.1692 6.25769 21.25 5.86294 21.25 5.46429C21.25 4.65916 20.9208 3.88702 20.3347 3.31771C19.7487 2.7484 18.9538 2.42857 18.125 2.42857C17.2962 2.42857 16.5013 2.7484 15.9153 3.31771C15.3292 3.88702 15 4.65916 15 5.46429C15 5.86294 15.0808 6.25769 15.2379 6.626C15.3949 6.99431 15.6251 7.32897 15.9153 7.61086C16.5013 8.18017 17.2962 8.5 18.125 8.5ZM8.75 7.28571C9.74456 7.28571 10.6984 6.90192 11.4017 6.21875C12.1049 5.53558 12.5 4.609 12.5 3.64286C12.5 2.67671 12.1049 1.75014 11.4017 1.06697C10.6984 0.3838 9.74456 0 8.75 0C7.75544 0 6.80161 0.3838 6.09835 1.06697C5.39509 1.75014 5 2.67671 5 3.64286C5 4.609 5.39509 5.53558 6.09835 6.21875C6.80161 6.90192 7.75544 7.28571 8.75 7.28571ZM18.125 10.9286C15.8375 10.9286 11.25 12.0457 11.25 14.2679V17H25V14.2679C25 12.0457 20.4125 10.9286 18.125 10.9286ZM8.75 9.71429C5.8375 9.71429 0 11.135 0 13.9643V17H8.75V14.2679C8.75 13.2357 9.1625 11.4264 11.7125 10.0543C10.625 9.83571 9.575 9.71429 8.75 9.71429Z" 
        fill="currentColor"
      />
    </svg>
  );
}; 